var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26891",
    "data-name": "Group 26891",
    transform: "translate(-126 -172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_35",
    "data-name": "Union 35",
    d: "M-246.581-100.109l-3.818-3.818-3.818,3.818a1.036,1.036,0,0,1-.736.3,1.036,1.036,0,0,1-.736-.3,1.039,1.039,0,0,1-.305-.736,1.033,1.033,0,0,1,.305-.735l3.818-3.818-3.818-3.82a1.032,1.032,0,0,1-.232-1.131,1.035,1.035,0,0,1,.964-.649,1.043,1.043,0,0,1,.744.314l3.814,3.813,3.814-3.814a1.029,1.029,0,0,1,.72-.315h.026a1.035,1.035,0,0,1,.96.642,1.033,1.033,0,0,1-.235,1.145l-3.814,3.815,3.818,3.818a1.033,1.033,0,0,1,.3.735,1.036,1.036,0,0,1-.3.736,1.036,1.036,0,0,1-.736.3A1.036,1.036,0,0,1-246.581-100.109Z",
    transform: "translate(388.398 289.401)",
    fill: "#002983"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6235",
    "data-name": "Rectangle 6235",
    transform: "translate(126 172)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.43299119b5da1c6b611b1dc70bcc8994.svg";
export { ForwardRef as ReactComponent };